// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 774 ? "framework" : chunkId) + "-" + {"491":"3e70257a35d233a234ab","774":"636746c5108120120e63","808":"1b2286f4f4911b1613fa","932":"5ffd254402c313147cd9"}[chunkId] + ".js";
};